import React from 'react'
import { useDispatch } from 'react-redux'
import { updatePickupLocationSetting } from '../reducers/pickup-location-settings'

const SelectPickupLocationsItem = ({item}) => {
  const elementId = 'dreamfox-pickup-location-field-' + item.name.replace(/\s+/g, '-')
  const dispatch = useDispatch()
  const handleDaysChanged = (e) => {
    const raw = e.target.value
    const days = raw === '' ? null : parseInt(raw, 10)
    dispatch(updatePickupLocationSetting({name: item.name, data: {days: isNaN(days) ? null : days}}))
  }
  return (
    <div className="dreamfox-select-categories-item">
      <div className="dreamfox-select-categories-item__check">
        <label htmlFor={elementId}>{item.name}</label>
      </div>
      <div>
        <input id={elementId} type="number" min="0" className="dreamfox-select-categories-item__number" value={item.days == null ? '' : item.days} onChange={handleDaysChanged} />
      </div>
    </div>
  )
}

export default SelectPickupLocationsItem
